const placeCaretBeforeTail = (el) => {
  if (!el) return;
  const marker = el.querySelector('[data-large-tail]');
  const sel = window.getSelection();
  if (!sel) return;
  try {
    const range = document.createRange();
    if (marker) range.setStartBefore(marker);
    else {
      range.selectNodeContents(el);
      range.collapse(false);
    }
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  } catch {
    /* ignore caret failures */
  }
};

const placeCaretAtOffset = (el, offset) => {
  if (!el) return;
  const text = el.firstChild;
  const sel = window.getSelection();
  if (!sel || !text || text.nodeType !== Node.TEXT_NODE) {
    placeCaretBeforeTail(el);
    return;
  }
  try {
    const range = document.createRange();
    range.setStart(text, Math.max(0, Math.min(offset, text.length)));
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  } catch {
    placeCaretBeforeTail(el);
  }
};

export { placeCaretAtOffset, placeCaretBeforeTail };
